import { CALL_USING_TYPE } from '~/core/constants'
import { getAutoCallIntoMeeting } from '~/selectors/feature-flags'
import store from './store'

let getCallSetupFn = () => ({ id: CALL_USING_TYPE.COMPUTER })

export const setCallSetup = fn => {
  if (fn) {
    getCallSetupFn = fn
  }
}

export default {
  getCallSetup: () => getCallSetupFn(),
  shouldDialIntoMeeting: () =>
    getCallSetupFn().id !== CALL_USING_TYPE.COMPUTER &&
    getAutoCallIntoMeeting(store.getState())
}
